import { useState } from 'react';
import { Pluralize } from '../common';
import { constants } from '../../constants';
import { SyndicateContact } from '../../types/loan/Loan';
import { SyndicateContactsPopup } from './SyndicateContactsPopup';
import { useAppSelector } from '../../effects/useAppSelector';

interface SyndicateContactsLinkProps {
    arrangerReferenceName: string;
    contacts?: SyndicateContact[];
}

export function SyndicateContactsLink({ arrangerReferenceName, contacts }: SyndicateContactsLinkProps) {
    const [visible, setVisible] = useState(false);
    const arranger = useAppSelector(s => s.entities.arrangers.items[arrangerReferenceName]);


    if (!contacts?.length) return <>{constants.emptyPlaceholder}</>;

    return (
        <>
            <button className="pseudo-link" onClick={() => setVisible(true)}>
                <Pluralize count={contacts.length} singular="contact" />
            </button>
            {visible && (
                <SyndicateContactsPopup
                    arrangerLegalName={arranger?.legalName}
                    contacts={contacts}
                    onClose={() => setVisible(false)}
                />
            )}
        </>
    );
}
